
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
import EuCheckbox from '../Checkbox/Checkbox.vue';
export default Vue.extend<any, any, any, any>({
  name: 'GeneralTopContent',
  data() {
    return {
      expand: false,
      check: false
    };
  },
  components: {
    EuButton,
    EuCard,
    EuCheckbox
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Information shown on card
     */
    cardInformation: {
      type: Object,
      required: true
    },
    /**
     * Selecting a card in multiselection
     */
    selected: {
      type: Boolean
    },
    /**
     * Set chekcbox to disabled
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Method to check a checkbox
       * @event check
       * @type {function}
       */
      this.$emit('check', e);
    }
  },
  computed: {
    checkTitleType() {
      return typeof this.cardInformation.title === 'string';
    }
  }
});
